module.exports = __webpack_public_path__ + "img/gll.e8065ba5.png";